module.exports = __webpack_public_path__ + "img/express-splitter-south.f3b53756.png";